import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["dataTestId", "disabled", "displayValue", "disableSearch", "onChange", "targetRef", "ariaLabel", "dataHjAllow", "value", "onClear"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Input } from "@faire/web--source/slate/Input";
import * as React from "react";
import { DropdownChevron } from "./DropdownChevron";
export var DropdownInput = function DropdownInput(_ref) {
  var dataTestId = _ref.dataTestId,
    disabled = _ref.disabled,
    displayValue = _ref.displayValue,
    disableSearch = _ref.disableSearch,
    onChange = _ref.onChange,
    targetRef = _ref.targetRef,
    ariaLabel = _ref.ariaLabel,
    dataHjAllow = _ref.dataHjAllow,
    value = _ref.value,
    onClear = _ref.onClear,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleChange = React.useCallback(function (e) {
    if (!disableSearch) {
      onChange(e);
    }
  }, [disableSearch, onChange]);
  return /*#__PURE__*/React.createElement(Input, _objectSpread(_objectSpread({}, props), {}, {
    "data-test-id": dataTestId,
    disabled: disabled,
    value: displayValue,
    inputMode: disableSearch ? "none" : undefined,
    onChange: handleChange,
    style: {
      width: "100%"
    },
    suffixNode: /*#__PURE__*/React.createElement(DropdownChevron, {
      value: value,
      onClear: onClear,
      disabled: disabled
    }),
    ref: targetRef,
    spellCheck: !disableSearch,
    "aria-label": ariaLabel,
    "data-hj-allow": dataHjAllow,
    hideCharacterCount: true
  }));
};